<template>
    <div class="c-account-settings">
        <BackButton />

        <h1>{{$t('account_settings.title')}}</h1>
        <div class="form">
            <div class="form--row anim">
                <div class="form--row--label"></div>
                <h2 >{{$t('account_settings.change_password')}}</h2>
            </div>
            <div v-if="showPasswordWarning" class="form--row password-warning anim">
                {{ $t('account_settings.password_warning') }}
            </div>
            <div class="form--row anim">
                <div class="form--row--label">{{$t('account_settings.current_password')}}</div>
                <input type="password" ref="oldPassword" class="inputfield" :class="{error : oldPasswordError}" v-model="oldPassword" autocomplete="password" tabindex="1"/>
                <button class="eye" @click.prevent="toggleInput('oldPassword')"></button>
            </div>
            <div class="form--row anim">
                <div class="form--row--label">{{$t('account_settings.new_password')}}</div>
                <input type="password" ref="password" class="inputfield" :class="{error : passwordError}" v-model="password" autocomplete="off" tabindex="2"/>
                <button class="eye" @click.prevent="toggleInput('password')"></button>
            </div>
            <div class="form--row anim">
                <div class="form--row--label">{{$t('account_settings.confirm_password')}}</div>
                <input type="password" ref="password2" class="inputfield" :class="{error : password2Error}" v-model="password2" autocomplete="off" tabindex="3"/>
                <button class="eye" @click.prevent="toggleInput('password2')"></button>
            </div>
            <div class="form--row anim">
                <div class="form--row--label"></div>
                <button class="btn-basic blue" @click.prevent="submit" :disabled="loading">{{$t('reset_pass.btn')}}</button>
            </div>
            <div class="form--row" v-if="feedback">
                <div class="form--row--label"></div>
                <div class="form--success">{{$t('account_settings.password_changed')}}</div>
            </div>
            <div class="form--row" v-if="passwordErrorLabel != ''">
                <div class="form--row--label"></div>
                <div class="form--error">{{$t('account_settings.'+passwordErrorLabel)}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import {apiStore} from "@/stores/api";

export default {
    name: "ResetPass",

    components: {
        BackButton
    },

    data() {
        return {
            oldPassword: "",
            password: "",
            password2: "",
            oldPasswordError: false,
            passwordError : false,
            password2Error : false,
            passwordErrorLabel : "",
            loading : false,
            serverError : false,
            feedback : false,
            showPasswordWarning: false
        };
    },

    created() {
        if (this.$router.currentRoute.params && this.$router.currentRoute.params.showPasswordWarning !== undefined) {
            this.showPasswordWarning = true;
        }
    },

    methods: {
        async submit() {
            this.passwordErrorLabel = "";
            this.oldPasswordError = false;
            this.passwordError = false;
            this.password2Error = false;

            if (this.oldPassword.trim() === "") {
                this.oldPasswordError = true;
            }

            if (this.password.trim() === "") {
                this.passwordError = true;
            }

            if (this.password2.trim() === "") {
                this.password2Error = true;
            }

            if (!this.oldPasswordError && !this.passwordError && !this.password2Error) {
                // regex to check for at least 8 characters, 1 uppercase, 1 lowercase, 1 number & also allow special characters
                const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W]{8,}$/;
                const match = this.password.match(regex);
                const passwordFormatError = match === null;
                if (passwordFormatError) {
                    this.passwordError = true;
                    this.passwordErrorLabel = "password_format_error";
                }

                // same passwords?
                if (this.password !== this.password2) {
                    this.passwordError = true;
                    this.password2Error = true;
                    this.passwordErrorLabel = "passwords_not_match";
                }

                if (this.passwordErrorLabel === "") {
                    this.loading = true;
                    try {
                        const response = await apiStore().updatePassword(this.oldPassword, this.password);
                        console.log(response);
                        this.handleResponse(response);
                    } catch (error) {
                        console.log("error", error);
                    } finally {
                        this.loading = false;
                    }
                }
            }
        },

        handleResponse(response) {
            if (response.error !== undefined) {
                this.passwordErrorLabel = response.error;

                if (this.passwordErrorLabel === "old_password_wrong") {
                    this.oldPasswordError = true;
                }
            } else {
                this.feedback = true;
            }
        },

        toggleInput(ref) {
            const input = this.$refs[ref];
            input.type = input.type === "password" ? "text" : "password";
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-account-settings {
        text-align: center;

        h1 {
            margin-top : 10vh;
        }

        h2 {
            @include slideIntroAnimation(basicSlideIntro, 750ms, 450ms);
        }

        .form {
            margin : 6vh auto;
            width : 60vw;

            .inputfield {
                width : 55%;
            }

            &--row {
                display: flex;
                position: relative;

                &.anim {
                    @for $i from 1 through 8 {
                        &:nth-child(#{$i}) {
                            @include slideIntroAnimation(basicSlideIntro, 750ms, #{350ms + $i * 350ms});
                        }
                    }
                }

                &--label {
                    padding-top: 1rem;
                    font-size: 1.5em;
                    width: 40%;
                    text-align: right;
                    margin-right: 5%;

                }
            }

            &--error {
                font-size: 1.25em;
                margin-left: 10rem;
                margin-top : 2rem;
                color : $color-red;
                text-align: left;
                width: 100%;
            }

            &--success {
                font-size: 1.25em;
                margin-top : 2rem;
                text-align: left;
                color : $color-green;
            }
        }

        .password-warning {
            margin-bottom: 1rem;
            font-size: 1.25em;
            color: $color-red;
            margin-left: 10rem;
        }

        .eye {
            @extend .reset-btn;
            background-image : url('/img/icon-eye.svg');
            background-repeat : no-repeat;
            background-size: 65%;
            background-position: center;
            width: 2.25rem;
            height: 2.25rem;
            outline: none;
            position: absolute;
            right: 0.45rem;
            top: 0.45rem;
        }
    }
</style>